export const CSS_VARIABLE_NAMES = {
	VIEWPORT_HEIGHT: '--viewport_height',
} as const;
